import { useState, useEffect } from 'react';
import betClient from '../../api/betClient';
import { useEffectiveTier } from '../../hooks/useEffectiveTier';
import { renderInlineMarkdown } from '../../utils/renderMarkdown';
import UpgradeModal from '../upgrade/UpgradeModal';

export default function LineAnalysis({ eventId, sport, hasLineData }) {
  const [analysis, setAnalysis] = useState(null);
  const [loading, setLoading] = useState(false);
  const tier = useEffectiveTier();
  const [modalOpen, setModalOpen] = useState(false);
  const locked = tier === 'free';

  useEffect(() => {
    if (!hasLineData || locked) return;
    setLoading(true);
    betClient.get(`/api/ai/line-analysis/${eventId}?sport=${sport}`)
      .then((r) => setAnalysis(r.data))
      .catch(() => setAnalysis(null))
      .finally(() => setLoading(false));
  }, [eventId, sport, hasLineData, locked]);

  if (!hasLineData) return null;

  if (locked) {
    return (
      <>
        <div className="rounded border-l-[3px] border-l-[#005BB3] dark:border-l-[#3b82f6] border border-[#E5E7EB] dark:border-[#1e2536] bg-[#F8F9FA] dark:bg-[#0f1219] px-4 py-3 -mt-1">
          <span className="text-[12px] font-medium uppercase tracking-[1px] text-[#005BB3] dark:text-[#3b82f6]" style={{ fontFamily: 'var(--font-sans)' }}>AI Line Analysis</span>
          <p className="text-[#6B7280] dark:text-[#8892a8] text-[11px] mt-1 mb-2">AI-powered analysis of line movement trends and sharp action.</p>
          <button onClick={() => setModalOpen(true)}
            className="px-3 py-1.5 rounded bg-[#94a3b8] text-white text-[11px] font-medium cursor-pointer flex items-center gap-1.5 opacity-80 hover:opacity-100 transition-opacity duration-150">
            View Analysis
            <span className="text-[9px] font-bold px-1 py-px rounded bg-white/20 uppercase">Pro</span>
          </button>
        </div>
        <UpgradeModal open={modalOpen} onClose={() => setModalOpen(false)} suggestedTier="pro" triggerFeature="Line Analysis" />
      </>
    );
  }

  return (
    <div className="rounded border-l-[3px] border-l-[#005BB3] dark:border-l-[#3b82f6] border border-[#E5E7EB] dark:border-[#1e2536] bg-[#F8F9FA] dark:bg-[#0f1219] px-4 py-3 -mt-1">
      <span className="text-[12px] font-medium uppercase tracking-[1px] text-[#005BB3] dark:text-[#3b82f6]" style={{ fontFamily: 'var(--font-sans)' }}>AI Line Analysis</span>
      {loading && <p className="text-[#6B7280] dark:text-[#8892a8] text-[11px] mt-1">Analyzing...</p>}
      {!loading && analysis?.content && <p className="text-[#1F2937] dark:text-[#8892a8] text-[14px] leading-relaxed mt-1" style={{ fontFamily: 'var(--font-sans)' }}>{renderInlineMarkdown(analysis.content)}</p>}
      {!loading && !analysis && <p className="text-[#6B7280] dark:text-[#8892a8] text-[11px] mt-1">Analysis unavailable.</p>}
    </div>
  );
}
